<template>
  <div id="dashboard-analytics">
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <vx-card
          slot="no-body"
          class="text-center bg-primary-gradient greet-user"
        >
          <!-- <img src="../assets/images/elements/decore-left.png" class="decore-left" alt="Decore Left" width="200" > -->
          <!-- <img src="../assets/images/elements/decore-right.png" class="decore-right" alt="Decore Right" width="175"> -->
          <feather-icon
            icon="AwardIcon"
            class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
            svgClasses="h-8 w-8"
          ></feather-icon>
          <h1 class="mb-6 text-white">Good {{ timeOfDay }},</h1>

          <p
            class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white"
            v-html="todaySummary"
          />
          <!-- <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white" v-else>There was <strong>{{weekTr}}</strong> site visits within the last week. Check your new badge in your profile.</p> -->
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
      <!-- CARD 9: DISPATCHED ORDERS -->
      <div class="vx-col w-full" v-if="fundRequests.length">
        <vx-card title="Ticket Requests">
          <div slot="no-body" class="mt-4">
            <vs-table :data="fundRequests">
              <template slot="thead">
                <!-- <vs-th>ORDER NO.</vs-th> -->
                <!-- <vs-th>STATUS</vs-th> -->
                <vs-th>Account</vs-th>
                <!-- <vs-th>LOCATION</vs-th> -->
                <!-- <vs-th>DISTANCE</vs-th> -->
                <vs-th>Tickets Requested</vs-th>
                <vs-th>Balance</vs-th>
                <vs-th>Payment Type</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].status">
                    <router-link :to="`/account/${tr.account.id}`">
                      {{ tr.account.name }}
                    </router-link>
                  </vs-td>
                  <vs-td>
                    {{ tr.qtyOrdered }} <em>({{ tr.productString }})</em>
                  </vs-td>
                  <vs-td>
                    {{ formatPrice(tr.balance) }}
                  </vs-td>
                  <vs-td>
                    {{ tr.type.toUpperCase() }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import { formatPrice } from "@/assets/helper";
function getLastWeek() {
  var today = new Date();
  var lastWeek = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() - 7
  );
  return lastWeek;
}
function getTodate() {
  var today = new Date();
  var lastWeek = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );
  return lastWeek;
}

export default {
  data: () => ({
    weekTr: null,
    todayTr: null,
    fundRequests: []
  }),
  computed: {
    todaySummary() {
      let { todayTr, weekTr } = this;
      let text = "";
      if (todayTr > 2)
        text = `There was <strong>${todayTr}</strong> site visits today.`;
      else if (weekTr > 0)
        text = `There was a total of <strong>${weekTr}</strong> site visits in the last 7 days.`;
      else text = `There were no Site visits in the last week.`;

      if (this.fundRequests && this.fundRequests.length) {
        text += ` You have ${this.fundRequests.length} fund requests.`;
      }
      return text;
    },
    timeOfDay() {
      let hour = new Date().getHours();
      let result = hour > 15 ? "evening" : hour > 12 ? "afternoon" : "morning";
      return result;
    }
  },
  methods: {
    formatPrice
  },
  async created() {
    if (!this.$store.getters.isManageTruckDriverOnly && !this.$store.getters.isManageAll) {
      let lastWeekString = getLastWeek().toISOString();
      let { data: weekTr } = await this.$get(
        `/ticket-useds/count?createdAt_gte=${lastWeekString}`
      );
      this.weekTr = weekTr;

      let todayString = getTodate().toISOString();
      let { data: todayTr } = await this.$get(
        `/ticket-useds/count?createdAt_gte=${todayString}`
      );
      this.todayTr = todayTr;

      let { data: fundRequests } = await this.$get(
        `/ticket-orders/?isPaid=0&_sort=updatedAt:DESC`
      );

      this.fundRequests = fundRequests.map(x => {
        let { orderItems = [], payments = [] } = x;
        x.qtyOrdered = 0;

        orderItems.forEach(({ quantity }) => {
          x.qtyOrdered += quantity;
        });

        x.balance = x.total;
        payments.forEach(paid => {
          if (!isNaN(paid.amount)) x.balance = x.balance - paid.amount;
        });

        console.log("X BALANCE", x.balance);

        let productString = orderItems[0].product.title;
        if (orderItems.length > 1) {
          productString = orderItems.length + " Products";
        }
        x.productString = productString;
        return x;
      });
    }

    // var lastWeekMonth = lastWeek.getMonth() + 1;
    // var lastWeekDay = lastWeek.getDate();
    // var lastWeekYear = lastWeek.getFullYear();

    // var lastWeekDisplay = lastWeekMonth + "/" + lastWeekDay + "/" + lastWeekYear;
    // var lastWeekDisplayPadded = ("00" + lastWeekMonth.toString()).slice(-2) + "/" + ("00" + lastWeekDay.toString()).slice(-2) + "/" + ("0000" + lastWeekYear.toString()).slice(-4);
  }
};
</script>
<style lang="scss">
#dashboard-analytics {
  .greet-user {
    position: relative;
    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
</style>
